import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OperationDetailSection } from '../utils/operation-detail-display.util';

@Component({
  selector: 'app-operation-detail-readonly',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  templateUrl: './operation-detail-readonly.component.html',
  styleUrl: './operation-detail-readonly.component.scss',
})
export class OperationDetailReadonlyComponent {
  sections = input.required<OperationDetailSection[]>();
}
